var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.2264 0.520264C84.6754 0.520264 98.7722 4.98036 110.592 13.2915C122.411 21.6026 131.377 33.3595 136.265 46.9566C141.153 60.5538 141.724 75.3283 137.901 89.2624C134.079 103.197 126.048 115.611 114.906 124.81C103.764 134.01 90.0536 139.546 75.6478 140.662C61.242 141.778 46.8428 138.42 34.4166 131.047C21.9904 123.674 12.1431 112.645 6.21938 99.466C0.295682 86.2871 -1.41557 71.6009 1.31932 57.4131L9.29877 58.9513C6.88058 71.4961 8.39367 84.4816 13.6314 96.1344C18.8691 107.787 27.5762 117.539 38.5634 124.058C49.5506 130.578 62.2824 133.547 75.02 132.56C87.7576 131.573 99.8801 126.678 109.732 118.544C119.584 110.41 126.684 99.4329 130.065 87.1124C133.445 74.7918 132.939 61.7282 128.618 49.7056C124.296 37.6831 116.368 27.2876 105.917 19.9389C95.4666 12.5902 83.0022 8.64661 70.2264 8.64661V0.520264Z",
    fill: "#37C2D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.5ed9809d.svg";
export { ForwardRef as ReactComponent };